import { memo } from "react";

import { Separator } from "@/components/ui/separator";

const Introduction = memo(() => {
  return (
    <>
      <div className="flex flex-col items-center justify-center text-center">
        <h1 className="text-xl md:text-3xl font-semibold text-primary">
          Pitch Critic
        </h1>
        <p className="text-base md:text-lg">
          Get a thorough analysis based on ATC’s criteria
        </p>
        <p className="text-xs md:text-sm text-muted-foreground">
          This is a project by ATC Venture Studio's Greenhouse
        </p>
      </div>
      <Separator className="my-8" />
    </>
  );
});

export { Introduction };
